// Generated by scripts/generate-build-info.ts — do not edit
export const buildInfo = {
  buildDate: "2026-09-25T01:25:10.109Z",
  buildId: "20260925-012510-f2681c1",
  gitSha: "f2681c1",
  version: "0.0.0",
} as const;
